var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":require('../assets/images/Vencasa-Leaf-Top-Border-4K.webp')}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-12",domProps:{"innerHTML":_vm._s(_vm.inner)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }